import firebase from 'firebase'

const config = {
  apiKey: 'AIzaSyAI2ZSdFVfcF2SddFgnKQsVCzA7CL02Rv0',
  authDomain: 'fldemo-6f519.firebaseapp.com',
  databaseURL: 'https://fldemo-6f519.firebaseio.com'
};

firebase.initializeApp(config);
const database = firebase.database();

export default database;



// WEBPACK FOOTER //
// ./src/Database/database.js